import * as React from 'react';
export var AnimationDirection;
(function(AnimationDirection) {
    /**
   * Grid will transition out and in horizontally
   */ AnimationDirection[AnimationDirection["Horizontal"] = 0] = "Horizontal";
    /**
   * Grid will transition out and in vertically
   */ AnimationDirection[AnimationDirection["Vertical"] = 1] = "Vertical";
})(AnimationDirection || (AnimationDirection = {}));
